import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import PropTypes from 'prop-types';
import ArbitratorFeeCalculator from '../ArbitrationFeeCalculator';
import ArbitrationProcedure from '../ArbitrationProcedure';
import ClausesAgreement from '../ClausesAgreement';
import ArbitrationAgreement from '../ArbitrationAgreement';
import ArbitrationRules from '../ArbitrationRules';
import ArbitrationList from '../ArbitrationList';
import AboutOnlineArbitration from '../AboutOnlineArbitration';
import ArbitrationListForView from '../ArbitrationListForView';
import LoginForm from '../../containers/Auth/LoginForm';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import ChangeLangaugeMenu from '../../components/ChangeLanguageMenu';
import GeneralDialog from '../../components/GeneralDialog';
import {setLanguage} from "redux-i18n";
import { connect } from 'react-redux';

const aboutOnlineArbitration = <AboutOnlineArbitration />;
const arbitrationRules = <ArbitrationRules />;
const arbitrationProcedures = <ArbitrationProcedure />;
const arbitrationAgreement = <ArbitrationAgreement />;
const onlineArbitrationClauses = <ClausesAgreement />;
const arbitratorFeeCalculator = <ArbitratorFeeCalculator />;
const arbitrationListForView = <ArbitrationListForView />;

const styles =  (theme) => ({
    list: {
      width: 250,
      marginLeft:'0px',
      marginRight:'0px',
      background: "#99192D",
      height:'100vh',
      color: 'white'
    },
    fullList: {
      width: 'auto',
    },
    nested: {
      paddingLeft: theme.spacing.unit * 4,
      color: 'white'
    },
    link: {
      textDecoration: 'none',
      color: 'white'
    },
});

class SideDrawerLogin extends Component{
    
  state = {
    openCaseFileList: false,
    openOnlineArbitrationList: false,
    openSettingList: false,
    procedure:true,
    value: 0,
    languages: ['English', '中文'],
    lan: ['en', 'cn'],
  };

  handleClick = (openList) => {
    this.setState(state => ({ [openList]: !state[openList] }));
  };

  handleChangeSelect = event => {
    this.props.setLanguage(this.state.lan[event.value]);
    this.setState({ [event.name]: event.value });
    console.log('handleChangeSelect language: event.value: '+event.value+' event.name: '+event.name)
    localStorage.setItem('language', this.state.lan[event.value]);
    
    // setTimeout(()=>{
    //     window.location.reload();
    // },1000)
  };

  
  render(){
    const { classes, toggleDrawer, openDrawer} = this.props;
  
    const sideList = (props) => (
        <div className={classes.list}>
          <List  component="nav">
          <Link to={''} onClick={toggleDrawer('left', false)} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText disableTypography style={{ textAlign: 'right' }} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF', fontSize:'25px', fontWeight:'bolder', }}>x</Typography>}
                   />
              </ListItem>
            </Link>
            <Link to={''} onClick={toggleDrawer('left', false)} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText onClick={()=>{ this.handleChangeSelect({value: 1, name: 1}) }} disableTypography style={{ textAlign: 'center' }} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF'}}>
                    中文
                  </Typography>}
                   />
                <ListItemText onClick={()=>{ this.handleChangeSelect({value: 0, name: 0}) }} disableTypography style={{ textAlign: 'center' }} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF'}}>
                    Eng
                  </Typography>}
                   />
              </ListItem>
            </Link>
            
            {/* <ChangeLangaugeMenu menuStyle={{width:'100%', marginLeft:'33px'}} /> */}
            <Link to={'/cases'} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText disableTypography style={{ textAlign: 'center'}} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF' }}>{this.context.t('About Online Arbitration')}</Typography>}
                   />
              </ListItem>
            </Link>
            <Link to={'/arbitrationRulesMain'} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText disableTypography style={{ textAlign: 'center'}} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF' }}>{this.context.t('Arbitration Rules')}</Typography>}
                   />
              </ListItem>
            </Link>
            <Link to={''} onClick={()=>{this.props.showDialog('showProcedure', true)}} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText disableTypography style={{ textAlign: 'center'}} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF' }}>{this.context.t('Arbitration Procedure')}</Typography>}
                   />
              </ListItem>
            </Link>
            
            <Link to={''} onClick={()=>{this.props.showDialog('showCalculator', true)}} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText disableTypography style={{ textAlign: 'center'}} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF' }}>{this.context.t('Arbitration Computer')}</Typography>}
                   />
              </ListItem>
            </Link>

            <Link to={''} onClick={()=>{this.props.showDialog('showOnlineArbitrationClauses', true)}} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText disableTypography style={{ textAlign: 'center'}} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF' }}>{this.context.t('Online Arbitration Clauses')}</Typography>}
                   />
              </ListItem>
            </Link>


            <Link to={''} onClick={()=>{this.props.showDialog('showArbitrationListForView', true)}} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText disableTypography style={{ textAlign: 'center'}} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF' }}>{this.context.t('Arbitrator’s List')}</Typography>}
                   />
              </ListItem>
            </Link>

            <Link to={'/login'} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText disableTypography style={{ textAlign: 'center'}} 
                  primary={<Typography type="body2" style={{ color: '#FFFFFF' }}>{this.context.t('Login')}</Typography>}
                   />
              </ListItem>
            </Link>

          </List>
        </div>
    );

    return(
      <div>
        <Drawer anchor="left" open={openDrawer} onClose={toggleDrawer('left', false)}>
          <div
              tabIndex={0}
              role="button"
              //onClick={toggleDrawer('right', false)}
              //onKeyDown={toggleDrawer('right', false)}
          >
              {sideList(toggleDrawer)}
              
          </div>
        </Drawer>
      </div>
  );
  }
    
}

const mapStateToProps = (state) => {
  return {
      lang: state.i18nState.lang,
  }
  
}

const mapDispatchToProps = (dispatch) => {
  return {
      setLanguage: (language) => dispatch(setLanguage(language)),
  }
}

SideDrawerLogin.contextTypes = {
  t: PropTypes.func
}

// export default withStyles(styles)(SideDrawerLogin);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SideDrawerLogin));